export default __webpack_public_path__ + "static/media/Prof-Leo-Brecht.8d036009.jpg";